import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class Nutzungsart extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    bezeichnung: string | null = null;
    auswertung_alle: boolean | null = null;
    auswertung_wohn_und_dienstleistungsgebaeude: boolean | null = null;
    auswertung_wohngebaeude: boolean | null = null;
    reihenfolge: number | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'Nutzungsart';
    }
}

export async function createNewNutzungsart(): Promise<Nutzungsart> {
    const nutzungsart = createModel(Nutzungsart, {});

    await nutzungsart.save();
    return nutzungsart;
}

export class NutzungsartCollection extends BaseCollection<Nutzungsart> {
    protected modelCls = Nutzungsart;

    public getModelClassName(): string {
        return 'Nutzungsart';
    }
}
